import * as Yup from "yup";
import { LEAD_TYPE } from "../../../pages/leads-management/models/ILead";

const phoneRegExp = /^(?:0|94|\+94)?(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;

export type UserSubmitForm = {
    firstName: string;
    lastName: string;
    address1: string;
    address2?: string;
    jobTitle?: string;
    company?: string,
    mobile:string,
    phone:string,
    email:string,
    noOfEmployees?:string,
    businessType?:string,
    revenue?:string,
};

export const getValidationSchema = (leadType: LEAD_TYPE) => {
  const isBusiness = leadType === LEAD_TYPE.BUSINESS;

  return Yup.object().shape({
    customer: Yup.mixed()
      .required("Customer is required")
      .test("is-valid", "Customer must be selected", (value) => !!value),

    address1: Yup.string()
      .required("Address 1 is required"),

    address2: Yup.string().nullable(),

    job: Yup.mixed()
      .required("Job is required")
      .test("is-valid", "Job must be selected", (value) => !!value),

    firstName: Yup.string()
      .required('First Name is required'),

    jobTitle: Yup.string().when([], {
      is: () => isBusiness,
      then: Yup.string().required('Job Title is required'),
      otherwise: Yup.string().notRequired(),
    }),

    company: Yup.string().when([], {
      is: () => isBusiness,
      then: Yup.string().required('Company is required'),
      otherwise: Yup.string().notRequired(),
    }),

    mobile: Yup.string()
      .required('Mobile is required'),

    email: Yup.string()
      .required('Email is required')
      .email('Email is invalid'),


    businessType: Yup.string().when([], {
      is: () => isBusiness,
      then: Yup.string().required('Business Type is required'),
      otherwise: Yup.string().notRequired(),
    }),
  });
};
